import { Component } from '@angular/core'
import { StoreNameObservable } from '../helpers/storeNameObservable'
import { AuthenticationService } from '../authentication/authentication.service';
import { NotificationBuilder } from '../shared/notificationBuilder';
import { ProfileService } from '../profile/profile.service';
import { NgxSmartModalService } from 'ngx-smart-modal';

declare var $: any;
//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    iconimg?: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [
    {
        path: '/profile/onboarding',
        title: 'Página Inicial',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/home-2.svg'
    },
    {
        path: '/profile/solutions',
        title: 'Produtos',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/grid.svg'
    },
    {
        path: '/transactions',
        title: 'Compras & Doações',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/shopping-cart.svg'
    },
    {
        path: '/profile/invoices',
        title: 'Faturas',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/dollar-sign.svg'
    },
    {
        path: '/profile/overview',
        title: 'Analytics',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/line-chart.svg'
    },
    {
        path: '/transparency',
        title: 'Transparência',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/eye.svg'
    },
    {
        path: '/compredoe',
        title: 'Selo CompreDoe',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/menu-esquerdo-compredoe-branco.svg'
    },
    {
        path: '/ngo/supportedNgos',
        title: 'Nosso Impacto',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/star.svg'
    },
    {
        path: '/ngo/storescontent',
        title: 'Nosso Conteúdo',
        type: 'link',
        icontype: null,
        iconimg: '../../assets/img/icon/inbox-white.svg'
    },
    {
        path: 'marketing-causa',//'https://marketing.polen.com.br/',
        title: 'Marketing de Causas',
        type: 'method',
        icontype: null,
        iconimg: '../../assets/img/icon/paperclip.svg'
    }
    // {
    //     path: '/campaign/list',
    //     title: 'Campanhas',
    //     type: 'link',
    //     icontype: null,
    //     iconimg: '../../assets/img/icon/flag.svg'
    // },
    // {
    //     path: '/customization',
    //     title: 'Caixinha de Doação',
    //     type: 'link',
    //     icontype: null,
    //     iconimg: '../../assets/img/icon/heart.svg'
    // },
    // {
    //   path: '/matchfunding',
    //   title: 'MatchFunding',
    //   type: 'link',
    //   icontype: 'link',
    //   iconimg: '../../assets/img/icon/users.svg'
    // }
    // {
    //     path: 'https://polen.com.br/faq',
    //     title: 'FAQ',
    //     type: 'external',
    //     icontype: null,
    //     iconimg: '../../assets/img/icon/paperclip.svg'
    // }
    // , {
    //     path: '/dashboard',
    //     title: 'Dashboard',
    //     type: 'sub',
    //     icontype: 'ti-bar-chart',
    //     children: [
    //         { path: 'overview', title: 'Visão geral', ab: '-' },
    //         { path: 'details1', title: 'Conversão', ab: '-' },
    //         { path: 'details2', title: 'Resultados de venda', ab: '-' },
    //         { path: 'details3', title: 'Interações', ab: '-' },
    //         { path: 'details4', title: 'Doações', ab: '-' }
    //     ]

    // {
    //     path: '/backers',
    //     title: 'Clientes Polinizadores',
    //     type: 'link',
    //     icontype: 'ti-people'
    // },
    // {
    //     path: '/setup',
    //     title: 'Setup',
    //     type: 'link',
    //     icontype: 'ti-layout'
    // },
];

export const FABRICAROUTES: RouteInfo[] = [
    {
        path: '/profile',
        title: 'Perfil',
        type: 'sub',
        icontype: 'ti-user',
        children: [
            { path: 'perfil', title: 'Meus Dados', ab: 'D' },
            // { path: 'users', title: 'Minha Equipe', ab: 'E'},
            // { path: 'tracking', title: 'Histórico de Acessos', ab: 'A' },
            { path: 'billing', title: 'Dados de Pagamento', ab: 'D' },
            { path: 'invoices', title: 'Faturas & Doações', ab: 'F' }
        ]
    },
    {
        path: '/transactions',
        title: 'Compras & Doações',
        type: 'link',
        icontype: 'ti-shopping-cart'
    },
    // {
    //     path: '/profile/overview',
    //     title: 'Analytics',
    //     type: 'link',
    //     icontype: 'ti-bar-chart'
    // },
    {
        path: '/backers',
        title: 'Clientes Polinizadores',
        type: 'link',
        icontype: 'fa fa-users'
    },
    {
        path: '/ngo/supportedNgos',
        title: 'Causas que apoio',
        type: 'link',
        icontype: 'ti-heart'
    },
    {
        path: '/setup',
        title: 'Setup',
        type: 'link',
        icontype: 'ti-layout'
    },
    {
        path: '/transparency',
        title: 'Transparência',
        type: 'link',
        icontype: 'ti-eye'
    }
];

export const TROCOSIMPLESROUTES: RouteInfo[] = [
    {
        path: '/transactions',
        title: 'Compras & Doações',
        type: 'link',
        icontype: 'ti-shopping-cart'
    },
    {
        path: '/profile/invoices',
        title: 'Faturas',
        type: 'link',
        icontype: 'ti-money',
    },
    {
        path: '/transparency',
        title: 'Transparência',
        type: 'link',
        icontype: 'ti-eye'
    }
];

//Menu Items
export const ADMINROUTES: RouteInfo[] = [
    {
        path: '/dashboard/stores',
        title: 'Lojas',
        type: 'link',
        icontype: 'ti-user'
    },
    {
        path: '/admin/campanhas',
        title: 'Campanhas',
        type: 'link',
        icontype: 'ti-announcement'
    },
    {
        path: '/dashboard/adminview',
        title: 'Analytics',
        type: 'link',
        icontype: 'ti-bar-chart'
    },
    {
        path: '/dashboard/admin-lead',
        title: 'Leads Polen',
        type: 'link',
        icontype: 'ti-heart-broken'
    },
    {
        path: '/dashboard/admin-plan',
        title: 'Planos Polen',
        type: 'link',
        icontype: 'ti-layers-alt'
    },
    {
        path: '/causes',
        title: 'Ongs',
        type: 'sub',
        icontype: 'ti-heart',
        children: [
            { path: 'organizations', title: 'Instituições', ab: 'O' },
            { path: 'invitation', title: 'Pré-Cadastro', ab: 'P' },
            { path: 'causes', title: 'Causas', ab: 'C' },
            { path: 'extrato', title: 'Extrato', ab: 'E' },
            { path: 'content', title: 'Conteúdos', ab: 'C' }
        ]
    },
    {
        path: '/admin',
        title: 'Admin',
        type: 'sub',
        icontype: 'ti-desktop',
        children: [
            { path: 'campanhas', title: 'Campanhas', ab: 'C' },
            { path: 'features', title: 'Features', ab: 'F' },
            { path: 'conciliation', title: 'Conciliacao', ab: 'C' },
            { path: 'recompra', title: 'Recompra', ab: 'R' },
            { path: 'problemas', title: 'Problemas', ab: 'P' },
            { path: 'materiais-educativos', title: 'Materiais', ab: 'M' }

        ]
    },
    // {
    //     path: '/admin/cause-icons',
    //     title: 'Icones de Causas',
    //     type: 'link',
    //     icontype: 'ti-brush'
    // },
    {
        path: '/dashboard/admin-metrics',
        title: 'Metricas',
        type: 'link',
        icontype: 'ti-dashboard'
    },
    {
        path: '/dashboard/admin-finance',
        title: 'Finanças',
        type: 'link',
        icontype: 'ti-money'
    },
    {
        path: '/bot',
        title: 'Lead Bot',
        type: 'link',
        icontype: 'ti-reddit'
    }
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent {
    public menuItems: any[]
    public normalMenu: boolean = true
    public storeName: String
    public storePlatform: string
    public storeList: any
    public storeIdSelected: any
    isAdmin: boolean = false;
    isAdminView: boolean = false;
    profile: any;
    profilePlan: any;
    percentageUsed:number = 0;
    percentageDays:number = 0;
    hasPlatform: boolean = false;
    canMakeCampain: boolean = false;


    constructor(private storeNameObservable: StoreNameObservable,
        private authenticationService: AuthenticationService,
        private profileService: ProfileService,
        public ngxSmartModalService: NgxSmartModalService,
        private notificationBuilder: NotificationBuilder) { }

    ngOnInit() {
        // this.storeNameObservable.getStoreName().subscribe(data => {
        //     this.storeName = data
        // });
        this.isAdmin = this.authenticationService.isAdministrator()
        var customization = localStorage.getItem("polenPainelCustomized")
        this.storeName = localStorage.getItem("storeName");
        this.storePlatform = localStorage.getItem("storePlatform");
        this.hasPlatform = this.storePlatform != "";
        this.storeList = this.authenticationService.getStoreList();

        this.verifyCampain();

        this.storeIdSelected = this.authenticationService.getStoreSelected();
        
        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        this.isAdminView = (this.authenticationService.isAdministrator() && !this.authenticationService.isImpersonatedButAdmin());
        //só exibe o navbar administrativo se nao estiver impersonando. Se impersonar mostra outro
        if (this.authenticationService.isAdministrator() && !this.authenticationService.isImpersonatedButAdmin()) {
            this.menuItems = ADMINROUTES.filter(menuItem => menuItem);
        }
        else {
            this.normalMenu = false;
            if (customization != null && customization == "trocosimples")
                this.menuItems = TROCOSIMPLESROUTES.filter(menuItem => menuItem);
            // else if (this.storeName != null && this.storeName == "Fábrica Camisaria")
            //     this.menuItems = FABRICAROUTES.filter(menuItem => menuItem);
            else if (this.storeName != null && this.storeName == "99 causas")
                this.menuItems = FABRICAROUTES.filter(menuItem => menuItem);
            else if (this.storeName != null && this.storeName == "Hero Seguros")
                this.menuItems = FABRICAROUTES.filter(menuItem => menuItem);
            else if (this.storeName != null && this.storeName == "My Travel Assist")
                this.menuItems = FABRICAROUTES.filter(menuItem => menuItem);
            else {
                this.normalMenu = true;
                this.profilePlan = this.authenticationService.getProfilePlanInfo();
                if (this.profilePlan == null) {
                    this.profileService.GetProfilePlanInfo().subscribe(res => {
                        if (res.success) {
                            this.authenticationService.setProfilePlanInfo(res.data);
                            this.profilePlan = res.data;
                            if (this.profilePlan.isBlocked){
                                this.notificationBuilder.showNotification('danger', 50000, "O Polen está encerrando suas atividades. Como sua empresa não está ativa a mais de 3 meses seus dados estão em processo de exclusão respeitando a LGPD.");
                                this.authenticationService.logout();
                                return;
                            }
                        }
                    })
                }
                if(this.profilePlan != null){
                    if (this.profilePlan.isBlocked){
                        this.notificationBuilder.showNotification('danger', 50000, "O Polen está encerrando suas atividades. Como sua empresa não está ativa a mais de 3 meses seus dados estão em processo de exclusão respeitando a LGPD.");
                        this.authenticationService.logout();
                        return;
                    }
                    if(this.profilePlan.planSeoName == 'free' ) this.percentageUsed = 100 - (this.profilePlan.orderConsume * 100) / this.profilePlan.orderMaxPlan;
                    if(this.profilePlan.planSeoName == 'trial' )this.percentageDays = (this.profilePlan.trialDaysLeft * 100) / this.profilePlan.trialMaxDays;
                    if ((this.profilePlan.planSeoName == 'free' || this.profilePlan.planSeoName == 'trial')){
                        setTimeout(() => {
                            $(".sidebar-wrapper").css("height", "57%");
                        }, 1000);
                    }
                }
                //this.menuItems = ROUTES.filter(menuItem => menuItem);
            }

        }



        isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
            $('html').addClass('perfect-scrollbar-on');
        } else {
            $('html').addClass('perfect-scrollbar-off');
        }

        // setTimeout(() => {
        //     $(".ti-announcement").parents('li').css('background-color', '#D5E5A3')
        // }, 500);

        this.activeActualItem();
    }

    verifyCampain()
    {
        let storeFeatures = localStorage.getItem("storeFeatures");
        
        if(storeFeatures != null && storeFeatures.includes("campanha"))
        {
            this.profileService.getCampaignList().subscribe(res=>{
                if(res.success)
                    this.canMakeCampain = res.data.length > 0;
            })
        }
    }

    changeActiveActualItem(e: any) {
        debugger
        var target = e.currentTarget;
        setTimeout(() => {
            $('.sidebar li').removeClass('active');
            $(target).parent().addClass('active');
        }, 100);

    }

    activeActualItem() {
        var url = window.location.hash.split('?')[0];
        setTimeout(() => {
            $(".sidebar li a").each(function (index) {
                if ($(this).attr('href') != undefined) {
                    var href = $(this).attr('href').split('?')[0];
                    if (url == href) {
                        $(this).parent().addClass('active');
                    }
                    //console.log( index + ": " + $( this ).attr('href') );
                }
            });
        }, 100);

    }

    warningAlert() {
        this.notificationBuilder.showNotification('warning', 5000, 'A integração BomTroco com a Loja Integrada está indisponível no momento. Entre em contato com nosso suporte')
    }

    changeStore(storeId, s) {
        if (this.authenticationService.getStoreSelected() != storeId) {
            var result = this.authenticationService.loginToStoreById(storeId);
            if (result) {
                setTimeout(() => {
                    $(".navbar").show()
                    $(".sidebar").show()
                    $(".main-panel").css("width", "");
                }, 100)
                //this.router.navigate(['/'])
                window.location.href = "/"
            }
            else {
                this.authenticationService.logout();
            }
        }
    }

    redirectMenu(id) {
        debugger
        if (id == 'marketing-causa') {
            this.profileService.getCurrentUserInfo().subscribe(profile => {
                console.log(profile)
                this.profile = profile;
                debugger
                if (this.profile.planSeoName == 'trial') {
                    this.ngxSmartModalService.getModal('marketingcauseModal').open()
                }
                else {
                    window.open('https://marketing.polen.com.br/', '_blank');
                }
            })
        }
    }

    isNotMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    ngAfterViewInit() {
        var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();

        var collapseId = $sidebarParent.siblings('a').attr("href");

        $(collapseId).collapse("show");
    }
}
